import media2 from "../assets/figma/media-2.png";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { CmsContent } from "./CmsContent";
import { InquiryForm } from "./InquiryForm";
import { useCmsBatch } from "../hooks/useCmsBatch";
import { CmsIcon } from "../utils/cmsIcons";

const valuesDefault = [
  { icon: "Trophy", title: "Growth-focused culture", body: "A team that measures success in player development, not just wins." },
  { icon: "Users", title: "Collaborative coaching", body: "Work alongside a coaching staff that shares notes, not just a field." },
  { icon: "Gauge", title: "Data-informed methodology", body: "Every session is backed by objective testing, not guesswork." },
  { icon: "ShieldCheck", title: "Safe, structured environment", body: "Consistent programming inside a premium, weather-proof facility." },
];

const CMS_KEYS = ["careers-hero", "careers-values"];

export function CareersPage() {
  const { content } = useCmsBatch(CMS_KEYS);
  const hero = content["careers-hero"] || {};
  const valuesSection = content["careers-values"] || {};
  const values = valuesSection.items?.length ? valuesSection.items : valuesDefault;

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container className="grid-12">
            <div className="section-copy">
              <p className="eyebrow lime"><span>01</span>Careers</p>
              <h2>{hero.title || "Join our coaching team."}</h2>
              <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 16 }}>
                {hero.body || "We're always looking for passionate coaches and staff who believe in objective, data-informed player development."}
              </p>
            </div>
            <div className="media-split-image">
              <img src={hero.mediaUrl || media2} alt="Coach working with a player at Formula Soccer Center" />
            </div>
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>02</span>Why coach with us</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>{valuesSection.title || "Built for coaches, too."}</h2>
            <div className="value-grid">
              {values.map((value) => (
                <div key={value.title} className="value-card">
                  <div className="value-card-icon"><CmsIcon name={value.icon} size={20} strokeWidth={1.5} /></div>
                  <h3>{value.title}</h3>
                  <p>{value.body}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>03</span>Open positions</p>
            <CmsContent
              contentKey="careers-openings"
              fallbackTitle="No open positions right now"
              fallbackBody="We don't have any open roles at the moment, but we're always happy to hear from passionate coaches and staff. Send us a note below and we'll keep you in mind."
            />
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>04</span>Get in touch</p>
            <h2 style={{ fontSize: "clamp(28px, 3.5vw, 42px)" }}>Introduce yourself.</h2>
            <InquiryForm
              source="careers"
              submitLabel="Submit interest"
              successMessage="Thanks for reaching out! We'll be in touch if there's a fit."
              messagePlaceholder="Tell us about your coaching background (optional)"
            />
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
